import React, { useMemo } from "react";
import { plans } from "../constants";
import { useActiveAccount } from "./useAccounts";

export function usePlan() {
  const { accountInfo } = useActiveAccount();

  return useMemo(
    () => plans.find((p) => p.id === accountInfo?.subscription.plan_id),
    [accountInfo?.subscription.plan_id]
  );
}
